import { PageSection } from 'components';
import { useTranslation } from 'react-i18next';
import { Container, SubmitButton, Subtitle, Title } from './styled';

const sectionConfig = {
    CWrap: {
        css: {
            transform: 'skewY(3deg)',
            backgroundColor: '#3DE8CA',
            borderRadius: '40px',
            padding: '130px 0 170px',
            position: 'relative',
            zIndex: 10,
            marginTop: '-80px',
            overflow: 'hidden',
            backgroundImage: 'url(/assets/alliance/alliance-outro-bg.png)',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',

            '@media(max-width: 767px)': {
                padding: '60px 0 80px',
                backgroundPosition: '100%',
            },
        },
    },
    ContentArea: {
        css: {
            display: 'block',
            position: 'relative',
            zIndex: 10,

            transform: 'skewY(-3deg)',

            '@media(max-width: 1023px)': {
                paddingTop: '0 !important',
            },
        },
    },
};

export const Outro = () => {
    const { t } = useTranslation('pages/academy-alliance');

    return (
        <PageSection config={sectionConfig}>
            <Container>
                <Title>{t('outro-title')}</Title>
                <Subtitle>{t('outro-subtitle')}</Subtitle>
                <SubmitButton
                    onClick={() =>
                        (window.location.href =
                            'mailto:academy.alliance@kaspersky.com')
                    }
                    color={'primary-contrast'}>
                    {t('request')}
                </SubmitButton>
            </Container>
        </PageSection>
    );
};
